var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.5,
    height: 36.142,
    viewBox: "0 0 36.5 36.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home_Appliaces",
    "data-name": "Home Appliaces",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2062771470944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37731",
    "data-name": "Group 37731",
    transform: "translate(15.568 1.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38201",
    "data-name": "Path 38201",
    d: "M1435.14,146.554a.582.582,0,0,0-.575.586v7.306H1434V147.14a1.14,1.14,0,0,1,1.14-1.14h18.141a1.142,1.142,0,0,1,1.151,1.14v31.777a1.142,1.142,0,0,1-1.151,1.14h-13.136v-.565h13.136a.582.582,0,0,0,.586-.575V147.14a.584.584,0,0,0-.586-.586Z",
    transform: "translate(-1434 -146)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38202",
    "data-name": "Path 38202",
    d: "M2014,1272.565h-14V1272h14a.288.288,0,0,1,.282.282A.28.28,0,0,1,2014,1272.565Z",
    transform: "translate(-1993.855 -1259.776)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38203",
    "data-name": "Path 38203",
    d: "M2875.064,523.565a.5.5,0,0,0-.5.5v4.885a.5.5,0,1,0,1.01,0v-4.885A.5.5,0,0,0,2875.064,523.565Zm0,6.46a1.068,1.068,0,0,1-1.064-1.075v-4.885a1.069,1.069,0,0,1,2.139,0v4.885A1.07,1.07,0,0,1,2875.064,530.024Z",
    transform: "translate(-2858.367 -518.907)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38204",
    "data-name": "Path 38204",
    d: "M2875.064,1594.554a.508.508,0,0,0-.5.51v4.9a.5.5,0,0,0,1.01,0v-4.9A.51.51,0,0,0,2875.064,1594.554Zm0,6.47a1.066,1.066,0,0,1-1.064-1.064v-4.9a1.069,1.069,0,0,1,2.139,0v4.9A1.068,1.068,0,0,1,2875.064,1601.024Z",
    transform: "translate(-2858.367 -1578.28)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38205",
    "data-name": "Path 38205",
    d: "M2066.264,1878.792a.272.272,0,0,1-.2-.087.275.275,0,0,1-.011-.391l3.159-3.246a.28.28,0,1,1,.4.391l-3.148,3.246A.318.318,0,0,1,2066.264,1878.792Z",
    transform: "translate(-2059.12 -1856.211)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38206",
    "data-name": "Path 38206",
    d: "M2156,2117.176l2.41-2.464a.279.279,0,0,1,.4-.011.288.288,0,0,1,0,.4l-2.019,2.073Z",
    transform: "translate(-2148.162 -2093.248)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37734",
    "data-name": "Group 37734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37732",
    "data-name": "Group 37732",
    transform: "translate(3.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38207",
    "data-name": "Path 38207",
    d: "M324.024,8.761V1.607H326a.127.127,0,0,1,.1.109V8.674a.1.1,0,0,1-.1.087ZM326.1,9.5h-1.552l.51-.467H326.1Zm-8.837-.467h.955l.51.467h-1.466Zm0-.358V1.715c0-.043.033-.109.076-.109h1.932V8.761h-1.932A.077.077,0,0,1,317.261,8.674Zm6.427-6.8h-4.082V1.607h4.082Zm-.934,2.269h-2.215V2.139h2.215Zm-.467.271h.434l-.434.673Zm-.945,0h.673v.934h-.673Zm-.261.717-.478-.717h.478Zm-1.476,3.626V2.139h.673V4.408l-.011.011.814,1.183v.89h.261V5.624h.673v.869h.271V5.559l.76-1.14-.033-.022V2.139h.673V8.761Zm4.169.271h.923l-.51.467h-.923Zm-3.919,0h3.561l-.51.467h-2.54Zm-.369,0L320,9.5h-.912l-.51-.467Zm.119-8.5a.21.21,0,0,1,.2-.2h3.735c.1,0,.152.1.152.2V1.4h-4.082ZM326,1.4h-1.976V.532A.511.511,0,0,0,323.536,0H319.8a.547.547,0,0,0-.532.532V1.4h-1.932a.32.32,0,0,0-.337.315V9.771h9.358V1.715A.34.34,0,0,0,326,1.4Z",
    transform: "translate(-317)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38208",
    "data-name": "Path 38208",
    d: "M364.782,222.314a.532.532,0,1,1,.532-.532A.533.533,0,0,1,364.782,222.314Zm0-1.314a.782.782,0,1,0,.782.782A.778.778,0,0,0,364.782,221Z",
    transform: "translate(-363.49 -218.601)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38209",
    "data-name": "Path 38209",
    d: "M403.285,259.774l-.51.51a.085.085,0,0,0,0,.119.08.08,0,0,0,.065.022c.022,0,.043,0,.054-.022l.51-.51a.084.084,0,0,0-.119-.119Z",
    transform: "translate(-401.819 -256.93)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38210",
    "data-name": "Path 38210",
    d: "M989.792,222.314a.532.532,0,1,1,.532-.532A.533.533,0,0,1,989.792,222.314Zm0-1.314a.782.782,0,1,0,0,1.563.782.782,0,1,0,0-1.563Z",
    transform: "translate(-981.704 -218.601)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38211",
    "data-name": "Path 38211",
    d: "M1029.285,259.774l-.51.51a.085.085,0,0,0,0,.119c.011.022.033.022.054.022a.08.08,0,0,0,.065-.022l.51-.51a.084.084,0,0,0-.119-.119Z",
    transform: "translate(-1021.023 -256.93)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37733",
    "data-name": "Group 37733",
    transform: "translate(0 9.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38212",
    "data-name": "Path 38212",
    d: "M116.417,1038.608H111.3a.3.3,0,1,1,0-.608h5.113a.3.3,0,0,1,0,.608Z",
    transform: "translate(-109.795 -1036.502)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38213",
    "data-name": "Path 38213",
    d: "M7.524,904.657H.3a.3.3,0,1,1,0-.6h7.22a.3.3,0,0,0,.293-.3v-3.463a.3.3,0,0,1,.608,0v3.463A.9.9,0,0,1,7.524,904.657Z",
    transform: "translate(0 -900)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38214",
    "data-name": "Path 38214",
    d: "M1123.16,1029.01l-1.151,1.14a.19.19,0,0,0,0,.271.228.228,0,0,0,.141.054.2.2,0,0,0,.13-.054l1.151-1.151a.2.2,0,0,0,0-.261A.19.19,0,0,0,1123.16,1029.01Zm-.391-1.01a1.764,1.764,0,1,0,1.759,1.759A1.768,1.768,0,0,0,1122.77,1028Zm0,2.953a1.194,1.194,0,0,1,0-2.388,1.194,1.194,0,1,1,0,2.388Zm4.9-1.943-1.14,1.14a.19.19,0,0,0,0,.271.2.2,0,0,0,.13.054.229.229,0,0,0,.141-.054l1.14-1.151a.177.177,0,0,0,0-.261A.19.19,0,0,0,1127.666,1029.01Zm-.391-1.01a1.764,1.764,0,1,0,1.77,1.759A1.765,1.765,0,0,0,1127.275,1028Zm0,2.953a1.194,1.194,0,1,1,1.194-1.194A1.188,1.188,0,0,1,1127.275,1030.953Z",
    transform: "translate(-1108.83 -1026.61)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38215",
    "data-name": "Path 38215",
    d: "M394.622,1741.3a3.686,3.686,0,0,1-3.691-3.68.3.3,0,1,1,.6,0,3.1,3.1,0,0,0,3.094,3.083.3.3,0,0,1,0,.6Zm0,1.281a4.967,4.967,0,1,1,4.961-4.961A4.969,4.969,0,0,1,394.622,1742.584Zm0-9.326a4.359,4.359,0,1,0,4.353,4.364A4.365,4.365,0,0,0,394.622,1733.258Zm0,10.976a6.617,6.617,0,1,1,6.612-6.612A6.619,6.619,0,0,1,394.622,1744.234Zm0-12.637a6.02,6.02,0,1,0,6.014,6.025A6.032,6.032,0,0,0,394.622,1731.6Z",
    transform: "translate(-383.788 -1721.978)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38216",
    "data-name": "Path 38216",
    d: "M35.507,1426.608H14V1426H35.507Z",
    transform: "translate(-13.848 -1420.289)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    y2: 24.666,
    transform: "translate(21.355 0.597)",
    fill: "none",
    stroke: "#282828",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38217",
    "data-name": "Path 38217",
    d: "M21.431,900H.673c-.326,0-.673.2-.673.521v24.666a.743.743,0,0,0,.673.684H21.431c.337,0,.532-.347.532-.684V900.521A.483.483,0,0,0,21.431,900Zm-.076,25.263H.6V900.6H21.355Z",
    transform: "translate(0 -900)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37735",
    "data-name": "Group 37735",
    transform: "translate(21.713 25.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38218",
    "data-name": "Path 38218",
    d: "M2010.7,2334.988h-3.615v-1.227h3.767v1.042C2010.856,2334.869,2010.77,2334.988,2010.7,2334.988Zm-10.7-9.575h6.688v9.575H2000v.412h10.748a.521.521,0,0,0,.521-.521v-9.358a.514.514,0,0,0-.521-.521H2000Zm10.856.185v7.762h-3.767v-7.947h3.615C2010.77,2325.413,2010.856,2325.521,2010.856,2325.6Z",
    transform: "translate(-2000 -2325)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38219",
    "data-name": "Path 38219",
    d: "M2712.205,2465.391a.811.811,0,0,1,.8.814.8.8,0,0,1-.8.8.811.811,0,0,1-.814-.8A.82.82,0,0,1,2712.205,2465.391Zm0,2.009a1.2,1.2,0,1,0-1.205-1.194A1.205,1.205,0,0,0,2712.205,2467.4Z",
    transform: "translate(-2703.281 -2463.48)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38220",
    "data-name": "Path 38220",
    d: "M2771.377,2526.279a.123.123,0,0,0,.087-.032l.782-.782a.113.113,0,0,0,0-.174.125.125,0,0,0-.185,0l-.771.771a.125.125,0,0,0,0,.185A.123.123,0,0,0,2771.377,2526.279Z",
    transform: "translate(-2762.877 -2523.076)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38221",
    "data-name": "Path 38221",
    d: "M2712.205,2777.008a.809.809,0,1,1,0-1.618.809.809,0,0,1,0,1.618Zm0-2.008a1.2,1.2,0,1,0,1.194,1.194A1.207,1.207,0,0,0,2712.205,2775Z",
    transform: "translate(-2703.281 -2770.115)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38222",
    "data-name": "Path 38222",
    d: "M2772.062,2835.032l-.771.782a.125.125,0,0,0,0,.185.133.133,0,0,0,.174,0l.782-.782a.125.125,0,0,0,0-.185A.148.148,0,0,0,2772.062,2835.032Z",
    transform: "translate(-2762.877 -2829.463)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38223",
    "data-name": "Path 38223",
    d: "M2005.157,2464.024H2000v.412h5.558V2457H2000v.4h5.157Z",
    transform: "translate(-2000 -2455.567)",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.6f70803e3755906ff540765907d54e17.svg";
export { ForwardRef as ReactComponent };